import { cn } from './cn.js';

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-slate-200/80 dark:bg-slate-800', className)}
      aria-hidden
    />
  );
}

/** Skeleta rindas sarakstu/tabulu ielādei. */
export function SkeletonRows({ rows = 4, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn('space-y-2.5', className)} aria-busy="true">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={String(i)} className={cn('h-9 w-full', i === 0 && 'w-2/3')} />
      ))}
    </div>
  );
}
